import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const ReactNative = () => {
  return (
    <StartInterviewLayout type="react-native"/>
  )
}

export default ReactNative;